import React, { ReactElement, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import { isNil } from "ramda";

import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import AppModal from "components/shared/modal/AppModal";

import { fetchMailTrackcenter } from "redux/handlers/mailDomainContainerHandler";

import { useAppDispatch } from "hooks/reduxHook";

const MailDomainTrackcenter = ({
 id,
 domain,
 type,
 closeMenu
}: {
 id: number;
 domain: string;
 type: string;
 closeMenu: () => void;
}): ReactElement => {
 const intl = useIntl();
 const dispatch = useAppDispatch();

 const [openModal, setOpenModal] = useState<boolean>(false);
 const [loading, setLoading] = useState<boolean>(false);
 const [from, setFrom] = useState<string>("");
 const [startDate, setStartDate] = useState(dayjs().subtract(1, "day"));

 const handleOpen = () => setOpenModal(true);
 const handleClose = () => setOpenModal(false);

 const handleConfirm = async () => {
  setLoading(true);
  if (type === "from")
   await dispatch(fetchMailTrackcenter(id, startDate.format("MMM D"), from, domain));
  else await dispatch(fetchMailTrackcenter(id, startDate.format("MMM D"), domain, from));
  setLoading(false);
  handleClose();
  closeMenu();
 };

 return (
  <>
   <MenuItem onClick={() => handleOpen()}>
    <FormattedMessage
     id={
      type === "from"
       ? "container.maildomains.checkMailLogsFrom"
       : "container.maildomains.checkMailLogsTo"
     }
    />
   </MenuItem>
   <AppModal
    open={openModal}
    close={handleClose}
    title={intl.formatMessage({
     id:
      type === "from"
       ? "container.maildomains.checkMailLogsFrom"
       : "container.maildomains.checkMailLogsTo"
    })}
    handleClose={handleClose}
    disabled={loading || isNil(startDate)}
    handleConfirm={handleConfirm}>
    <Stack spacing={2}>
     <Typography variant="subtitle2">
      <FormattedMessage id="container.maildomains.checkMailLogsMessage" />
     </Typography>
     <DatePicker
      label={<FormattedMessage id="container.maildomains.date" />}
      value={startDate}
      maxDate={dayjs()}
      disableFuture
      onChange={(newValue) => setStartDate(newValue?.startOf("day") || dayjs().startOf("day"))}
     />
     <TextField
      autoComplete="new-password"
      label={
       <FormattedMessage
        id={type === "from" ? "container.maildomains.from" : "container.maildomains.to"}
       />
      }
      value={from}
      InputLabelProps={{ shrink: true }}
      onChange={({ currentTarget }) => setFrom(currentTarget.value)}
     />
    </Stack>
   </AppModal>
  </>
 );
};

export default MailDomainTrackcenter;
